import { Button } from '@mui/material';
import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { FaFilePdf } from 'react-icons/fa';
import { useParams } from 'react-router-dom';

const UserDetailsPage = () => {
  const { id } = useParams();
  const [user, setUser] = useState({});
  const [userUpdateDate, setUserUpdateDate] = useState('');
  const [userDetailsIsFilled, setUserDetailsIsFilled] = useState(false);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await axios.get(
          `https://kariyer.biyomed.net/api/admin/getOneUserDetailsAdmin/${id}`, // id'yi nesne içine aldık
          { withCredentials: true } // Cookie gönderimi için
        );
        setUserUpdateDate(response.data.user.created_at)
        const res = await axios.get(
          `https://kariyer.biyomed.net/api/admin/getOneUserAdmin/${id}`, // id'yi nesne içine aldık
          { withCredentials: true } // Cookie gönderimi için
        );

        setUserDetailsIsFilled(true);
        setUser({ ...res.data.user, ...response.data.user });
      } catch (error) {
        console.error("Error fetching user:", error);
        setUserDetailsIsFilled(false);
      }
    };

    if (id) {
      fetchUser();
    }
  }, [id]);  // id değişirse yeniden çalıştır



  const handleDownload = (pdfData, fileName) => {
    if (pdfData && pdfData.startsWith('data:application/pdf;base64,')) {
      const base64Data = pdfData.split('base64,')[1];  // Base64 verisini ayıklama

      const pdfBlob = new Blob([new Uint8Array(atob(base64Data).split("").map(c => c.charCodeAt(0)))], { type: 'application/pdf' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(pdfBlob);

      link.href = url;
      link.download = fileName; // Kullanıcının indireceği dosya adı
      link.click();

      // URL'yi serbest bırak
      URL.revokeObjectURL(url);
    } else {
      console.error("Geçersiz Base64 verisi:", pdfData);
      alert("Geçersiz PDF verisi.");
    }
  };





  return (
    <div className="jp_cp_profile_main_wrapper">
      <Button sx={{ backgroundColor: "#4b88bd", marginTop: -20 }}><a style={{ color: 'white' }} href='/admin/kullanicilar'> Geri don</a></Button>
      <div className="container">
        <div className="row">
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
            <div className="jp_cp_left_side_wrapper">
              <div className="jp_cp_left_pro_wallpaper">
                <img src={user.profile_image ? user.profile_image : " https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png"} alt="profile_img" />

              </div>
            </div>
          </div>
          {userDetailsIsFilled ? (
            <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12">
              <div className="jp_cp_right_side_wrapper">
                <div className="jp_cp_right_side_inner_wrapper">
                  <h2>Kullanıcı Detay</h2>
                  <table>
                    <tbody>
                      <tr>
                        <td className="td-w25">Kayıt Bilgileri Güncelleme Tarihi</td>
                        <td className="td-w10">:</td>
                        <td className="td-w65">
                          {new Date(userUpdateDate).toLocaleString()} {/* Hem tarihi hem de saati göstermek için */}
                        </td>
                      </tr>
                      <tr>
                        <td className="td-w25">Ad</td>
                        <td className="td-w10">:</td>
                        <td className="td-w65">{user?.first_name}</td>
                      </tr>
                      <tr>
                        <td className="td-w25">Soyad</td>
                        <td className="td-w10">:</td>
                        <td className="td-w65">{user?.last_name}</td>
                      </tr>
                      <tr>
                        <td className="td-w25">E-posta</td>
                        <td className="td-w10">:</td>
                        <td className="td-w65">{user?.email}</td>
                      </tr>
                      <tr>
                        <td className="td-w25">Telefon</td>
                        <td className="td-w10">:</td>
                        <td className="td-w65">{user?.phone}</td>
                      </tr>
                      <tr>
                        <td className="td-w25">Profil Linki</td>
                        <td className="td-w10">:</td>
                          <td className="td-w65">
                          <a style={{ color: "blue" }} href={user?.profile_link1?.startsWith('http') ? user.profile_link1 : `https://${user.profile_link1}`}>
                          {user?.profile_link1}
                          </a>
                          </td>
                      </tr>
                      <tr>
                        <td className="td-w25">Profil Linki 2</td>
                        <td className="td-w10">:</td>
                                                <td className="td-w65">
                          <a style={{ color: "blue" }} href={user?.profile_link2?.startsWith('http') ? user.profile_link2 : `https://${user.profile_link2}`}>
                          {user?.profile_link2}
                          </a>
                          </td>
                      </tr>
                      <tr>
                        <td className="td-w25">Diller</td>
                        <td className="td-w10">:</td>
                        <td className="td-w65">{user?.languages?.replace(/\./g, ' ').replace(/,/g, ', ')}</td>
                      </tr>
                      <tr>
                        <td className="td-w25">İş Durumu</td>
                        <td className="td-w10">:</td>
                        <td className="td-w65">{user?.job_status}</td>
                      </tr>
                      <tr>
                        <td className="td-w25">Askerlik</td>
                        <td className="td-w10">:</td>
                        <td className="td-w65">{user?.military_status}</td>
                      </tr>
                      <tr>
                        <td className="td-w25">İlgi Alanları</td>
                        <td className="td-w10">:</td>
                        <td className="td-w65">{user?.category_of_interest}</td>
                      </tr>
                      <tr>
                        <td className="td-w25">Pozisyon tag</td>
                        <td className="td-w10">:</td>
                        <td className="td-w65">{user?.position_tags}</td>
                      </tr>
                      <tr>
                        <td className="td-w25">Yeterlilik Etiketleri </td>
                        <td className="td-w10">:</td>
                        <td className="td-w65">{user?.competency_tags}</td>
                      </tr>
                      <tr>
                        <td className="td-w25">Şehir</td>
                        <td className="td-w10">:</td>
                        <td className="td-w65">{user?.residence_city}</td>
                      </tr>
                      <tr>
                        <td className="td-w25">{user.user_type === "Mezun" ? 'Mezuniyet Yılı' : 'Tahmini Mezuniyet Yılı'}</td>
                        <td className="td-w10">:</td>
                        <td className="td-w65">{user?.graduation_year}</td>
                      </tr>
                      <tr>
                        <td className="td-w25">Türkçe Özgeçmiş</td>
                        <td className="td-w10">:</td>
                        <td>
                          {user.cv_turkish ?
                            <Button
                              variant="outlined"
                              color="primary"
                              onClick={() => handleDownload(user.cv_turkish, `${user.first_name}_cv_turkish.pdf`)}
                              startIcon={<FaFilePdf />}
                            >
                              Belgeyi indir
                            </Button> : <p>Mevcut Değil</p>
                          }
                        </td>
                      </tr>
                      <tr>
                        <td className="td-w25">İngilizce Özgeçmiş</td>
                        <td className="td-w10">:</td>
                        <td>
                          {user.cv_english ?
                            <Button
                              variant="outlined"
                              color="primary"
                              onClick={() => handleDownload(user.cv_english, `${user.first_name}_cv_english.pdf`)}
                              startIcon={<FaFilePdf />}
                            >
                              Belgeyi indir
                            </Button> : <p>Mevcut Değil</p>
                          }
                        </td>
                      </tr>
                      <tr>
                        <td className="td-w25">Mezuniyet/Öğrenci belgesi</td>
                        <td className="td-w10">:</td>
                        <td>
                          {user.graduation_document && (
                            <Button
                              variant="outlined"
                              color="primary"
                              onClick={() => handleDownload(user.graduation_document, `${user.first_name}_graduation_document.pdf`)}
                              startIcon={<FaFilePdf />}
                            >
                              Belgeyi indir
                            </Button>
                          )}
                        </td>
                      </tr>
                    </tbody>

                  </table>


                </div>

                <div className="row">
                  <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12">
                    <div className="jp_cp_accor_heading_wrapper">
                      <h2>Eğİtİm</h2>
                      <p> Phd: {user.phd ? user.phd : "Mevcut Degil"} </p>
                      <p> Yuksek Lisans : {user.masters} </p>
                      <p> Lisans  : {user.undergraduate}</p>
                      <p> Lise  : {user.highschool}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div> Detay Bilgileri Yükleniyor Lütfen Bekleyiniz ...</div>
          )}
        </div>
      </div>

    </div>
  );
};

export default UserDetailsPage;
